import React, { Fragment } from "react";
import T from "prop-types";
import { get } from "lodash";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import classNames from "classnames";

function Row({ lineItem, lineItemIds, partKey, serialKey, setLineItemIds }) {
  const selectItem = id => {
    const index = lineItemIds.indexOf(id);
    const [...arr] = lineItemIds;
    if (index !== -1) {
      arr.splice(index, 1);
      setLineItemIds(arr);
    } else {
      setLineItemIds(arr.concat([id]));
    }
  };

  return (
    <tr>
      <td style={{ marginBottom: "6px" }}>
        <input
          name="line_items"
          type="checkbox"
          className="pointer"
          checked={lineItemIds.includes(lineItem.id)}
          onChange={() => selectItem(lineItem.id)}
        />
      </td>
      <td>{get(lineItem, partKey)}</td>
      <td>{get(lineItem, serialKey)}</td>
    </tr>
  );
}

Row.propTypes = {
  lineItem: T.shape({}),
  lineItemIds: T.arrayOf(T.number),
  partKey: T.string,
  serialKey: T.string,
  setLineItemIds: T.func.isRequired
};

function Form(props) {
  const labelClasses = classNames("btn btn-default", {
    active: props.includeSoldTo
  });
  return (
    <Fragment>
      <table
        className="table table-striped table-hover table-numbered"
        style={{ marginBottom: 0 }}
      >
        <thead>
          <tr>
            <td />
            <td>Part #</td>
            <td>Serial #</td>
          </tr>
        </thead>
        <tbody>
          {props.record.line_items.map(l => (
            <Row
              partKey={props.partKey}
              serialKey={props.serialKey}
              lineItem={l}
              lineItemIds={props.lineItemIds}
              setLineItemIds={props.setLineItemIds}
            />
          ))}
        </tbody>
      </table>
      <br />
      <FormRow>
        <Col md={6}>
          <div className="form-group">
            <div
              className="btn-group btn-group-justified"
              data-toggle="buttons"
            >
              <label htmlFor="sold_to" className={labelClasses}>
                <input
                  type="checkbox"
                  id="sold_to"
                  checked={props.includeSoldTo}
                  onChange={() => {
                    props.setIncludeSoldTo(!props.includeSoldTo);
                  }}
                />
                <i className={`fa fa-lg fa-check-circle`} />
                &nbsp;&nbsp;Include Sold To
              </label>
            </div>
          </div>
        </Col>
      </FormRow>
    </Fragment>
  );
}

Form.propTypes = {
  lineItemIds: T.arrayOf(T.number),
  record: T.shape({}),
  serialKey: T.string,
  partKey: T.string,
  setLineItemIds: T.func.isRequired
};

export default Form;



// WEBPACK FOOTER //
// ./app/modules/shared/components/DownloadPackingSlipModal/Form.jsx